type PageNavigatorProps = {
  current: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  prevLabel: string;
  nextLabel: string;
};

export default function PageNavigator({
  current,
  total,
  onPrev,
  onNext,
  prevLabel,
  nextLabel,
}: PageNavigatorProps) {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={onPrev}
        disabled={current <= 1}
        className="flex-1 flex items-center justify-center gap-1 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed text-gray-600 rounded-xl font-medium transition-all cursor-pointer px-2 py-2.5 text-sm"
      >
        <i className="ri-arrow-left-s-line text-lg"></i>
        {prevLabel}
      </button>
      <div className="bg-indigo-50 rounded-xl font-semibold text-indigo-700 whitespace-nowrap text-center px-3 py-2.5 text-sm min-w-[70px]">
        {current} / {total}
      </div>
      <button
        onClick={onNext}
        disabled={current >= total}
        className="flex-1 flex items-center justify-center gap-1 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed text-gray-600 rounded-xl font-medium transition-all cursor-pointer px-2 py-2.5 text-sm"
      >
        {nextLabel}
        <i className="ri-arrow-right-s-line text-lg"></i>
      </button>
    </div>
  );
}
